import React from 'react';
import { Spinner, Text, VStack } from '@chakra-ui/react';

const LoadingSpinner = ({ 
  size = "xl", 
  text = "Loading", 
  py = 8, 
  showText = true,
  ref,
  ...props 
}) => {
  return (
    <VStack spacing={4} align="center" py={py} {...props}>
      <Spinner size={size} ref={ref} />
      {showText && <Text>{text}</Text>}
    </VStack>
  );
};

export default React.memo(LoadingSpinner); 